export const getParametersWithAutomation =
    (track) => {
        let params = track.trackData ? track.getAllParameters()
            .filter(x => x.automations)
            .filter(x => x.automations.length > 0) : [];
        return Array.from(new Set(params));
    };
